import { Serializable } from "@/core/api/decorators/serializable_decorator"

export interface B2BExtensionData {
  countryCode?: string
  countryName?: string
  companyName?: string
  companyVATNumber?: string
  companyAddress?: string
  firstname?: string
  lastname?: string
  phone?: string
  email?: string
}

@Serializable
export class B2BExtensionModel {
  countryCode: string = ""
  countryName: string = ""
  companyName: string = ""
  companyVATNumber: string = ""
  companyAddress: string = ""
  firstname: string = ""
  lastname: string = ""
  phone: string = ""
  email: string = ""

  constructor(data: B2BExtensionData | null = null) {
    if (data) {
      this.countryCode = data.countryCode ?? ""
      this.countryName = data.countryName ?? ""
      this.companyName = data.companyName ?? ""
      this.companyVATNumber = data.companyVATNumber ?? ""
      this.companyAddress = data.companyAddress ?? ""
      this.firstname = data.firstname ?? ""
      this.lastname = data.lastname ?? ""
      this.phone = data.phone ?? ""
      this.email = data.email ?? ""
    }
  }
}
